
import store from "@/store/index";
import { Message } from "element-ui";
import dayjs from "dayjs";
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string") {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), "/");
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTimeFn  (time, option) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  // if (diff < 30) {
  //   return '刚刚'
  // } else if (diff < 3600) {
  //   // less 1 hour
  //   return Math.ceil(diff / 60) + '分钟前'
  // } else if (diff < 3600 * 24) {
  //   return Math.ceil(diff / 3600) + '小时前'
  // } else if (diff < 3600 * 24 * 2) {
  //   return '1天前'
  // }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getFullYear() +
      "年" +
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split("?")[1]).replace(/\+/g, " ");
  if (!search) {
    return {};
  }
  const obj = {};
  const searchArr = search.split("&");
  searchArr.forEach(v => {
    const index = v.indexOf("=");
    if (index !== -1) {
      const name = v.substring(0, index);
      const val = v.substring(index + 1, v.length);
      obj[name] = val;
    }
  });
  return obj;
}
/**
 * @param {string} url
 * @returns {Object}
 */
export function getServiceTime(e, connat) {
  let _timeYear = "";
  let _time = "";
  _timeYear = e.start_time.substr(0, 10);
  _time = `${e.start_time.substr(11)} ${connat} ${e.end_time.substr(11)}`;
  return `${_timeYear} (${_time})`;
}
// 获取id数组
export function getIds(list, key) {
  let arr = [];
  if (list && list.length) {
    list.forEach(item => {
      arr.push(item[key]);
    });
  }
  return arr;
}
// 获取论坛星星数， 5个为一阶段
export function starNum(count) {
  let _num = [];
  if (count >= 0 && count < 10) {
    _num = [1];
  } else if (count >= 10 && count < 15) {
    _num = [1, 2];
  } else if (count >= 15 && count < 20) {
    _num = [1, 2, 3];
  } else if (count >= 20 && count < 25) {
    _num = [1, 2, 3, 4];
  } else if (count >= 25 && count < 3000) {
    _num = [1, 2, 3, 4, 5];
  }
  return _num;
}

// 清洗请求参数
export function cleanParams(data) {
  let _obj = {};
  if (data) {
    Object.keys(data).forEach((key) => {
      if (data[key] === 0 || data[key]) {
        _obj[key] = data[key];
      }
    });
  } else {
    _obj = "";
  }

  return _obj;
}

// 检测登录状态

export function checkLogin(cb){
  if(store.state.token){
    cb && cb()
  }else{
    Message.warning("请先进行登录")
  }
}

  // 获取会员权限
  export function getVipAuth(){
    let _obj = {};
    let _userVip = store.state.userVip;
    if(_userVip){
      _obj.limit = 9;
      _obj.maxSize = 10;
      _obj.videoMaxSize = 100;
      _obj.limitTip = "10MB";
      _obj.videoLimitTip = "100MB";
    }else{
      _obj.limit = 3;
      _obj.maxSize = 2;
      _obj.videoMaxSize = 5;
      _obj.limitTip = "2MB";
      _obj.videoLimitTip = "5MB";
    };
    return _obj;
  };

export function formatTime(time, option, noS) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  // if (diff < 30) {
  //   return '刚刚'
  // } else if (diff < 3600) {
  //   // less 1 hour
  //   return Math.ceil(diff / 60) + '分钟前'
  // } else if (diff < 3600 * 24) {
  //   return Math.ceil(diff / 3600) + '小时前'
  // } else if (diff < 3600 * 24 * 2) {
  //   return '1天前'
  // }
  if (option) {
    return parseTime(time, option);
  } else {
    let year = d.getFullYear();
    let month = d.getMonth() + 1;
    let strDate = d.getDate();

    let h = d.getHours(); //获取当前小时数(0-23)
    let m = d.getMinutes(); //获取当前分钟数(0-59)
    let s = d.getSeconds();

    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    let dateTime =
      year +
      "-" +
      month +
      "-" +
      strDate +
      " " +
      conver(h) +
      ":" +
      conver(m);

      if (!noS) {
        dateTime = dateTime +  ":" +  conver(s);
      }
    return dateTime;
  }
}

// 日期时间处理
function conver(s) {
  return s < 10 ? "0" + s : s;
}

// 根据传入的时间计算相对时间
export function formatTimeDiff(time) {
  const currentTime = dayjs();
  const targetTime = dayjs(time);

  const diffMinutes = currentTime.diff(targetTime, "minute");
  const diffHours = currentTime.diff(targetTime, "hour");
  const diffDays = currentTime.diff(targetTime, "day");

  if (diffMinutes < 1) {
    return "刚刚";
  } else if (diffMinutes < 60) {
    return `${diffMinutes}分钟前`;
  } else if (diffHours < 24) {
    return `${diffHours}小时前`;
  } else if (diffDays < 7) {
    return `${diffDays}天前`;
  } else {
    return targetTime.format("YYYY-MM-DD"); // 具体日期
  }
}
// 根据传入的时间计算相对时间
export function formatTimestamp(time) {
    return dayjs(time).format("YYYY-MM-DD HH:mm");
}

// base64转换成file 文件
 export function base64ToFile(base64, filename) {
      const arr = base64.split(',');
      const mime = arr[0].match(/:(.*?);/)[1]; // 获取 MIME 类型
      const bstr = atob(arr[1]); // 解码 base64
      const n = bstr.length;
      const u8arr = new Uint8Array(n);

      for (let i = 0; i < n; i++) {
          u8arr[i] = bstr.charCodeAt(i); // 将字符转换为字节
      }

      return new File([u8arr], filename, { type: mime }); // 创建 File 对象
    } 
    export function downloadPdf(pdfUrl,fileName) {
      fetch(pdfUrl)
        .then(response => response.blob())
        .then(blob => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(error => {
          console.error('Error:', error);
        });
    }


// WEBPACK FOOTER //
// ./src/utils/index.js